module.exports = __webpack_public_path__ + "static/media/photo136.5ab59c22.jpg";